import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 10000 });

export async function createPlayer(payload) {
  const { data } = await api.post("/players", payload);
  return data;
}

export async function getPlayer(id) {
  const { data } = await api.get(`/players/${id}`);
  return data;
}

export async function listPlayers() {
  const { data } = await api.get(`/players`);
  return data;
}

export async function updateProgress(id, payload) {
  const { data } = await api.put(`/players/${id}/progress`, payload);
  return data;
}

export async function updateMode(id, mode) {
  const { data } = await api.put(`/players/${id}/mode`, { mode });
  return data;
}

export async function getJournal(id) {
  const { data } = await api.get(`/players/${id}/journal`);
  return data;
}

export async function paymentsConfig() {
  const { data } = await api.get(`/payments/config`);
  return data;
}

export async function createCheckoutSession(payload) {
  const { data } = await api.post(`/payments/checkout`, payload);
  return data;
}

export async function paymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

export async function playerTransactions(id) {
  const { data } = await api.get(`/players/${id}/transactions`);
  return data;
}

export async function generatePortrait(playerId, description, lang = "fr") {
  const { data } = await api.post(`/ai/portrait`, { player_id: playerId, description, lang }, { timeout: 60000 });
  return data;
}

export async function generateGrimoirePage(pageId, childName, playerId, lang = "fr") {
  const { data } = await api.post(
    `/ai/grimoire-page`,
    { page_id: pageId, child_name: childName, player_id: playerId, lang },
    { timeout: 60000 }
  );
  return data;
}

export async function generateTTS(text, voice = "fable", speed = 1.0, lang = "fr", playerId = null) {
  const { data } = await api.post(`/ai/tts`, { text, voice, speed, lang, player_id: playerId }, { timeout: 30000 });
  return data;
}

export function ttsUrl(relativePath) {
  return `${process.env.REACT_APP_BACKEND_URL}${relativePath}`;
}

// ============ Family / Multi-profiles ============
export async function createFamily(payload) {
  const { data } = await api.post(`/families`, payload);
  return data;
}

export async function getFamily(familyId) {
  const { data } = await api.get(`/families/${familyId}`);
  return data;
}

export async function addChild(familyId, payload) {
  const { data } = await api.post(`/families/${familyId}/children`, payload);
  return data;
}

export async function updateScreenTime(playerId, payload) {
  const { data } = await api.put(`/players/${playerId}/screen-time`, payload);
  return data;
}

export async function generateGiftCode(familyId, tier = "premium") {
  const { data } = await api.post(`/gift-codes/generate`, { family_id: familyId, tier });
  return data;
}

export async function listGiftCodes(familyId) {
  const { data } = await api.get(`/gift-codes/family/${familyId}`);
  return data;
}

export async function redeemGiftCode(code, playerId) {
  const { data } = await api.post(`/gift-codes/redeem`, { code, player_id: playerId });
  return data;
}

export async function sendWeeklyReport(familyId, overrideEmail) {
  const { data } = await api.post(
    `/parental/weekly-report`,
    { family_id: familyId, override_email: overrideEmail },
    { timeout: 30000 }
  );
  return data;
}

export async function previewWeeklyReport(familyId) {
  const { data } = await api.get(`/parental/weekly-report/preview/${familyId}`);
  return data;
}

export async function scheduleGift(payload) {
  const { data } = await api.post(`/scheduled-gifts`, payload);
  return data;
}

export async function listScheduledGifts(familyId) {
  const { data } = await api.get(`/scheduled-gifts/family/${familyId}`);
  return data;
}

export async function sendScheduledGift(giftId) {
  const { data } = await api.post(`/scheduled-gifts/${giftId}/send`);
  return data;
}

export async function reportCustomLevel(shareCode, reason, reporterId) {
  const { data } = await api.post(`/custom-levels/report`, {
    share_code: shareCode, reason, reporter_player_id: reporterId,
  });
  return data;
}

export async function submitFlashResult(playerId, levelId, seconds, solved) {
  const { data } = await api.post(`/flash-challenge/result`, {
    player_id: playerId, level_id: levelId, seconds, solved,
  });
  return data;
}

export async function getAchievements(playerId) {
  const { data } = await api.get(`/players/${playerId}/achievements`);
  return data;
}

export async function claimAchievements(playerId, achievementIds) {
  const { data } = await api.post(`/players/${playerId}/achievements/claim`, {
    achievement_ids: achievementIds,
  });
  return data;
}

export async function trackLanguage(playerId, lang) {
  const { data } = await api.post(`/players/${playerId}/track-language`, { lang });
  return data;
}

export async function preSignup(email, platform, lang, source) {
  const { data } = await api.post(`/pre-signup`, { email, platform, lang, source });
  return data;
}

export async function betaRedeem(code, playerId) {
  const { data } = await api.post(`/beta/redeem`, { code, player_id: playerId });
  return data;
}
